// Shared marketing-site footer. Verbatim 1447-char footer block from the
// bedd.dev snapshots — bytes-identical across all 5 source pages. Internal
// hrefs are rewritten to SPA paths; placeholder `#` hrefs remain `#` (the
// original About / Blog / Help / Contact / Privacy / Terms / Cookies / social
// links did not point anywhere on bedd.dev either). The landing page itself
// will continue to keep its own legal/social links wired separately if we
// later promote any of these to real routes.

export function footerMarkup(): string {
  return `<footer class="site-footer">
  <div class="container">
    <div class="footer-top">
      <div class="footer-brand-wrap">
        <div class="footer-brand">BIMAssess</div>
        <div class="footer-tag">The benchmark for BIM professionals. Built by BIM professionals, for BIM professionals. Aligned to Autodesk standards, trusted by the teams that hire.</div>
      </div>
      <div class="footer-col">
        <h5>Product</h5>
        <ul>
          <li><a href="/individual" data-spa-link>For Individual</a></li>
          <li><a href="/business" data-spa-link>For Business</a></li>
          <li><a href="/catalogue" data-spa-link>Catalogue</a></li>
          <li><a href="/pricing" data-spa-link>Pricing</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <h5>Resources</h5>
        <ul>
          <li><a href="#">About</a></li>
          <li><a href="#">Blog</a></li>
          <li><a href="#">Help Center</a></li>
          <li><a href="#">Contact</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <h5>Legal</h5>
        <ul>
          <li><a href="/legal/privacy" data-spa-link>Privacy</a></li>
          <li><a href="/legal/terms" data-spa-link>Terms</a></li>
          <li><a href="/legal/cookies" data-spa-link>Cookies</a></li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom">
      <span>© 2026 BIMAssess </span>
      <div class="footer-bottom-links">
        <a href="#">LinkedIn</a>
        <a href="#">X</a>
        <a href="#">Email</a>
      </div>
    </div>
  </div>
</footer>`;
}
